import React, { useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import CameraComponent from "../registration/CameraComponent";
import { MdAttachFile } from "react-icons/md";
import { FaCamera, FaFilePdf } from "react-icons/fa";


/**
 * PersonalIdComponent
 * 
 * component to allow customer to take a photo of his personal ID.
 * 
 * @param {personalId} props - setter for personalId object in Inquarypage
 * @param {step} props - setter for next step in InquaryPage
 * 
 * @returns next step
 */
const PersonalIdComponent = ({ setStep, data, setData, errors, setErrors }) => {

    const [cameraShow, setCameraShow] = useState(false);
    const [photo, setPhoto] = useState(data.partner.x_file_ausweiskopie);
    
    /**
     * Handlers
     */
    const getBase64 = (file) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setPhoto(reader.result);
            if (reader.result.split(",")[0].includes('data:application/pdf')) {
                setData(prev => ({
                    ...prev,
                    partner: ({ ...prev.partner, 
                        x_file_ausweiskopie: reader.result.split(",")[1],
                        x_file_ausweiskopie_name: file.name,
                        x_file_ausweiskopie_pdf: true,
                    })
                }))
            } else {
                setData(prev => ({
                    ...prev,
                    partner: ({ ...prev.partner, 
                        x_file_ausweiskopie: reader.result.split(",")[1],
                        x_file_ausweiskopie_name: "",
                        x_file_ausweiskopie_pdf: false,
                    })
                }));
            }
        }
    }


    // Button "Weiter" click. If hasTakenPhoto=true, sets base64 image to Inquary page and moves to next screen
    const nextHandler = () => {
        if (photo !== "") {
            setStep(7);
        }
    }


    return (
        <div>
            <Row className="mb-5">
                <h5 className="text-energo">Ausweis</h5>
            </Row>
            <Row className="mt-3">
                <Col>
                    <b>Für eine reibungslose Kommunikation mit den Energieanbietern und Netzbetreibern benötigen wir einen Identitätsnachweis von Ihnen. (Gültige Dateiformate: Bilddateien oder PDF)</b>
                </Col>
            </Row>
            <Row className="mt-5 justify-content-center">
                <Col xs="12" hidden={data.partner.x_file_ausweiskopie !== ""}>
                    <Button 
                        onClick={() => setCameraShow(true)} 
                        style={{marginRight: 20}}
                        className="btn-energo"
                    >
                        <FaCamera />&nbsp; Kamera
                    </Button>
                    <input 
                        type="file" 
                        hidden 
                        name="attachment" 
                        id="attachment" 
                        accept="image/png, image/gif, image/jpeg, application/pdf" 
                        onChange={e => getBase64(e.target.files[0])}
                    />
                    <a 
                        onClick={e => {e.preventDefault(); document.getElementById('attachment').click()}}
                        href="upload/" 
                        className="link-energo"
                    >
                        <MdAttachFile size={25} /> Datei anhängen
                    </a>
                    <p className="mt-3">Bitte fotografieren Sie Ihr  Ausweisdokument oder laden Sie eine entsprechende Bilddatei hoch.</p>
                </Col>
            </Row>
            <Row className="mt-3 mb-5 justify-content-center" style={{ zIndex: 2 }}>
                <Col xs="8" hidden={data.partner.x_file_ausweiskopie === ""}>
                    {data.partner.x_file_ausweiskopie_pdf === true?
                        <p className="text-energo"><FaFilePdf /> {data.partner.x_file_ausweiskopie_name}</p>
                    :
                        <img src={`data:image/*;base64,${data.partner.x_file_ausweiskopie}`} className="img-fluid" alt=""/>
                    }
                    <Button
                        style={{borderTopLeftRadius: 0, borderTopRightRadius: 0}}
                        variant="warning"
                        onClick={() => setData(prev => ({...prev, partner: ({...prev.partner, x_file_ausweiskopie: ""})}))}
                    >
                        Nochmal versuchen
                    </Button>
                </Col>
                <CameraComponent show={cameraShow} setShow={setCameraShow} photo={data.partner.x_file_ausweiskopie} setPhoto={setPhoto} setData={setData} />
            </Row>
            <Row>
                <Col className="text-end">
                    <Button variant="warning" onClick={() => setStep(5)} style={{ marginRight: 5 }}>Zurück</Button>
                    <Button onClick={() => nextHandler()} className="btn-energo">Weiter</Button>
                </Col>
            </Row>
        </div>
    )
}

export default PersonalIdComponent;